import { type ReactElement } from 'react';
import { close } from 'ionicons/icons';

import { IonButton, IonButtons, IonFooter, IonHeader, IonIcon, IonModal, IonToolbar } from '@ionic/react';

import './ts-modal-drawer-common.scss';

type IonModalProps = React.ComponentProps<typeof IonModal>;

export interface TSModalProps extends IonModalProps {
  className?: string;
  heightPercentage?: number;
  footerBorder?: boolean;
  isOpen: boolean;
  handleXClick?: () => void;
  titleContent?: ReactElement;
  mainContent: ReactElement;
  footerContent?: ReactElement;
}

export const TSModal = ({
  className = '',
  heightPercentage,
  footerBorder = true,
  isOpen,
  handleXClick,
  titleContent,
  mainContent,
  footerContent,
  ...props
}: TSModalProps) => {
  const maxHeight = heightPercentage ? `${heightPercentage}vh` : '100%';
  const combinedClassNames = `ts-modal ${className}`;

  return (
    <IonModal
      isOpen={isOpen}
      className={combinedClassNames}
      style={
        !heightPercentage
          ? { '--height': 'fit-content', '--max-height': `90vh` }
          : { '--height': `${Math.min(heightPercentage, 100)}vh` }
      }
      {...props}
    >
      {(titleContent || handleXClick) && (
        <IonHeader className="ion-no-border">
          <IonToolbar>
            {titleContent && <div className="title-content">{titleContent}</div>}
            {handleXClick && (
              <IonButtons slot="end">
                <IonButton className="close-button" onClick={handleXClick}>
                  <IonIcon icon={close} />
                </IonButton>
              </IonButtons>
            )}
          </IonToolbar>
        </IonHeader>
      )}
      <div className="modal-body">
        <div style={{ maxHeight }} className="content">
          {mainContent}
        </div>
      </div>
      {footerContent && (
        <IonFooter className={`footer-content ${footerBorder ? '' : 'ion-no-border no-footer-border'}`}>
          <IonToolbar>{footerContent}</IonToolbar>
        </IonFooter>
      )}
    </IonModal>
  );
};
